export enum ESegmentTranscriptionStatus {
  NEW = 'new',
  TRANSCRIPTION_RECEIVED = 'transcription_received',
  COMPLETED = 'completed',
  FAILED = 'failed',
}
